let language = {
    CART_TABLE_TITLE_PRODUCT: "Products",
    CART_TABLE_TITLE_QUANTITY: "Quantity",
    CART_TABLE_TITLE_UNITED_PRICE: "Unit Price",
    CART_TABLE_TITLE_PRICE: "Price",
    CART_TABLE_TITLE_OPERATION: "Operation",
    CART_TABLE_TITLE_PREVIEW: "PREVIEW",
    CART_TABLE_TITLE_NAME: "Name",
    CART_TABLE_TITLE_EDIT: "EDIT",
    CART_ADD_TO_STORE:"Add To Store",
    CART_EMPTY:"Shopping cart is empty !",
    CART_GO_SHOPPING:"go shopping",
    CART_CONTINUE:"Continue",
    
}

export { language }